/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CheckFile } from './checkFile';

export interface HoaiCheckResult { 
    id?: string;
    status?: HoaiCheckResult.StatusEnum;
    started_at?: Date;
    rules?: Array<string>;
    files?: Array<CheckFile>;
}
export namespace HoaiCheckResult {
    export type StatusEnum = 'PENDING' | 'COMPLETED' | 'FAILED';
    export const StatusEnum = {
        PENDING: 'PENDING' as StatusEnum,
        COMPLETED: 'COMPLETED' as StatusEnum,
        FAILED: 'FAILED' as StatusEnum
    };
}